<template>
    <ul class="hotel-featured-list">
        <h5 class="font400 text-uppercase mb-15 font16">Caracteristicas</h5>
        <li>
            <span class="absolute">Tamaño:</span>
            Esta sala cuenta con una capacidad de 10 personas
        </li>
        <li>
            <span class="absolute">Horario:</span>
            - Abre a las 09:00 AM <br/>
            - Cierra a las 23:00 PM
        </li>
        <li>
            <span class="absolute">Método de acceso:</span>
            - Tarjeta NFC <br/>
            - Huella Digital <br/>
            - Código Numérico
        </li>
    </ul>
</template>

<script>
    export default {
        name: "meetingFacts"
    }
</script>

<style scoped>

</style>